/**
 * Recipients (sellers) who have opted out of asking buyers for an email
 * address on their public payment pages. Used by `PaymentFlow` to hide
 * the email field and skip its validation. The buyer still gets a
 * working invoice; the seller just won't have a contact for that buyer.
 *
 * Match by either:
 *   • wallet address (lowercased) — the canonical id, survives username
 *     changes
 *   • cashtap username — convenient to add by hand
 *
 * Either match disables the email prompt. To opt a seller out, add their
 * wallet AND/OR username here and ship.
 */
const DISABLED_EMAIL_WALLETS: ReadonlySet<string> = new Set([
  "0x7528b6d863caf1a03d3e3ded6955fce02f29a3c3", // meetme
  "0xa9da84da10d5c5098fd50329c5240b8817bcc81c", // datewithme
]);

const DISABLED_EMAIL_USERNAMES: ReadonlySet<string> = new Set([
  "meetme",
  "datewithme",
]);

export function isEmailDisabledFor({
  wallet,
  username,
}: {
  wallet?: string | null;
  username?: string | null;
}): boolean {
  if (wallet && DISABLED_EMAIL_WALLETS.has(wallet.toLowerCase())) return true;
  if (username && DISABLED_EMAIL_USERNAMES.has(username.toLowerCase())) return true;
  return false;
}
